/**
 * @file ラジオボタンによる表示切り替え
 *
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname ChangeListTypeSelect
 * @classdesc リスト新規登録・編集時のリスト種別の切り替え
 */
export default class ChangeListTypeSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#select-list-type')
	 */
	constructor($e, controller) {
		console.log('ChangeListTypeSelect.constructor')
		this._$e = $e
		this._controller = controller
		this._$memberIdListWrap = $('#membership-number-wrap')
		this._$titleListWrap = $('#title-wrap')
		this._$e.on('change', () => this.onChange())
		this.onChange(0)
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeListTypeSelect
	 * @return {undefined}
	 */
	onChange(duration = 300) {
		console.log('ChangeListTypeSelect.onChange')
		if (this._$e.val() === 'membership-number') {
			this._$memberIdListWrap.slideDown(duration).find('.validate').removeClass('ignore-validate')
			this._$titleListWrap.slideUp(duration)
			Common.addIgnoreValidate(this._$titleListWrap)
		}

		if (this._$e.val() === 'title') {
			this._$titleListWrap.slideDown(duration).find('.validate').removeClass('ignore-validate')
			this._$memberIdListWrap.slideUp(duration)
			Common.addIgnoreValidate(this._$memberIdListWrap)
			this._controller.countSelectedCategorizedItems()
		}
	}
}
